/**
 * FairChild Institute Typography Configuration
 * Centralized typography settings
 */

export const typography = {
  fontFamily: "'Bricolage Grotesque', system-ui, sans-serif",
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  heading: {
    fontWeight: 600,
    color: '#121212',
  },
  body: {
    fontWeight: 400,
    color: '#404040',
  },
} as const;

